import { ComponentBaseProps } from "[root]/src/lib";
import clsx from "clsx";

type CardBodyProps = Pick<ComponentBaseProps, "children" | "className">;

export const CardBody = ({ children, className }: CardBodyProps) => {
  return <div className={clsx("card-body", className)}>{children}</div>;
};
